import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_DAY, STR_DAYS, STR_PAID, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED, STR_UNPAID } from "../Strings";
import { MdCall, MdHotel, MdMessage, MdTimer, MdTimer10, MdTimeToLeave, MdWhatsapp } from "react-icons/md";
import { TbBrandDaysCounter } from "react-icons/tb";

export default function View({ data, viewer }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		if(viewer === 'manager') {
			appContext.navTo({
				item: "view",
				subItem: "manage-room-order",
				extraItem: data.id,
			});
		} else {
			appContext.navTo({
				item: "view",
				subItem: "room-order",
				extraItem: data.id,
			});
		}
	}

	return (
		<div className="card mNoShadow" onClick={view}>
			<div className="card-body">
				<div className="d-flex justify-content-between">
					<span 
						className="badge bg-dark"
						style={{
							fontSize: "12px"
						}}
					>
						{formatDate(data.dateCreated)}
					</span>

					<span 
						className={(data.isPaid === 'yes') ? "badge bg-success" : "badge bg-danger"}
						style={{
							fontSize: "12px",
							textTransform: "uppercase"
						}}
					>
						{(data.isPaid === 'yes') ? STR_PAID[appContext.language] : STR_UNPAID[appContext.language]}
						
					</span>
				</div>

				<h6
					style={{
						fontSize: "14px"
					}}
					className="mt-2"
				>
					{data.hotelName}
				</h6>

				<h6
					style={{
						fontSize: "18px"
					}}
				>
					TZS {formatMoney(Math.floor(data.overallCost))}
				</h6>

				<h6
					style={{
						fontSize: "14px"
					}}
					className="mt-2"
				>
					<TbBrandDaysCounter size={28}/> {data.numberOfDays} {(Number(data.numberOfDays) > 1) ? STR_DAYS[appContext.language] : STR_DAY[appContext.language]}
				</h6>

				<h6
					style={{
						fontSize: "32px"
					}}
					className="text-end mt-3"
				>
					<MdHotel/>
					<br/>
					{data.hotelRoomName}
				</h6>
			</div>
		</div>
	);
}
